import { render } from "./ProductGridWithPromoTiles.vue?vue&type=template&id=ef0f1e56&scoped=true"
import script from "./ProductGridWithPromoTiles.vue?vue&type=script&lang=js"
export * from "./ProductGridWithPromoTiles.vue?vue&type=script&lang=js"

import "./ProductGridWithPromoTiles.vue?vue&type=style&index=0&id=ef0f1e56&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef0f1e56"]])

export default __exports__